export default function getLocalization(stringKey) {
  if (typeof window.dominion_screenReaderText === 'undefined' || typeof window.dominion_screenReaderText[stringKey] === 'undefined') {
    // eslint-disable-next-line no-console
    console.error(`Missing translation for ${stringKey}`);
    return '';
  }
  return window.dominion_screenReaderText[stringKey];
}
